/**
 * Placeholder for an absent or empty value, shared by the version history panel
 * and both version modals so the three cannot drift. The em dash, not the date
 * module's `NOT_AVAILABLE` ('NA'): that one marks a definite absence, this one
 * empty/unknown.
 */
export const NOT_AVAILABLE = '—';
